import { render, staticRenderFns } from "./ReviewTypeList.vue?vue&type=template&id=4bb061ba&"
import script from "./ReviewTypeList.vue?vue&type=script&lang=js&"
export * from "./ReviewTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports